import React from "react";
import Select from "react-select";
import { Stack, Label, FontIcon, getTheme, Text } from "@fluentui/react";
import { useField } from "formik";

function FluentSelect({ description, ...props }) {
  // eslint-disable-next-line no-unused-vars
  const [field, meta, helpers] = useField(props);
  const { options } = props;
  const theme = getTheme();

  const customStyles = {
    control: (styles, state) => ({
      ...styles,
      borderRadius: 4,
      borderColor: state.isFocused
        ? theme.palette.themePrimary
        : "#aaaaaa",
      minHeight: 32,
    }),
    valueContainer: (styles) => ({
      ...styles,
      paddingTop: 0,
    }),
    menu: (styles) => ({
      ...styles,
      marginTop: 0,
    }),
    menuList: (styles) => ({
      ...styles,
      padding: 0,
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      maxWidth: "26px",
    }),
  };

  const onChange = (option) => {
    helpers.setValue(option ? option.value : null);
  };

  const onChangeMultiSelect = (option) => {
    if (option && option.length > 0) {
      helpers.setValue(option.map((item) => item.value));
    } else {
      helpers.setValue([]);
    }
  };

  const getValue = () => {
    if (options) {
      return props.isMulti
   
        ? options.filter((option) => {
            return field.value?.indexOf(option.value) >= 0;
          })
        : options.find((option) => option.value === field.value);
    } else {
      return props.isMulti ? [] : "";
    }
  };

  return (
    <Stack.Item>
      <Label>{props.label}</Label>
      <Select
        styles={customStyles}
        components={{
          IndicatorSeparator: () => null,
          ...(props.isClearable ? {} : { ClearIndicator: () => null }),
          DropdownIndicator: () => (
            <FontIcon
              iconName="ChevronDown"
              style={{ paddingRight: "7px", fontSize: "12px" }}
            />
          ),
        }}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: "#EDEBE9",
          },
        })}
        onChange={props.isMulti ? onChangeMultiSelect : onChange}
        value={getValue()}
        {...props}
      />
      {description && <Text variant="xSmall">{description}</Text>}
    </Stack.Item>
  );
}

export default FluentSelect;
